<template>
      <v-dialog v-model="dialog" persistent width="750px" >
        <v-card>
          <div class="container_flex">
            <v-card-title primary-title class="justify-center item_title">
              <span class="dialog-card__titulo">{{message}}</span>
            </v-card-title>
            <div class="close_button">
              <v-btn large icon @click="$router.push({ name: 'home' })">
                <i class="bexsicon-close" @click="$router.push({ name: 'home' })" />
              </v-btn>
            </div>
          </div>
          <v-card-text>
            <div class="grey lighten-3 dialog-card__border">
              <v-container>
                <p class="dialog-card__text" v-html="messageInformation">
                  {{ messageInformation }}
                </p>
              </v-container>
            </div>
          </v-card-text>
          <v-card-actions>
            <div>
              <v-checkbox v-model="checkbox" class="ml-3" label="Li e concordo com os termos acima."></v-checkbox>
            </div>

            <v-spacer></v-spacer>
            <v-btn class="mr-2 mb-3"
              color="green accent-4 text-blue white--text"
              text
              :disabled="!checkbox"
              @click="dialog = false"
            >Aceitar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>


<script>
import enums from '@/utils/enums';

export default {
  data() {
    return {
      dialog: true,
      checkbox: false
    };
  },
  props: {
    message: String,
    messageInformation: String
  },
  mounted() {},
  created() {}
};
</script>

<style lang="scss" scoped>
.dialog-card__border {
  border-radius: 5px;
}

.dialog-card__text {
  color: #666666;
  font-size: 13.7px;
  font-family: 'Open Sans';
}

.dialog-card__titulo {
  color: #666666;
  font-size: 20px;
  font-family: 'Open Sans';
}

.container_flex {
  display: flex;
}

.item_title {
  flex: 2;
  padding-right: 0px;
  padding-left: 70px;
}

.close_button {
  padding-top: 16px;
}

.dialog-checkbox__label {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue